import React, { Component } from 'react';
import { connect } from 'react-redux';
// import * as ContractSearch from '../ContractSearch/Saga/ContractSearch';
// import ContractSearchComponent from '../ContractSearch/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import Draggable from 'react-draggable'; // The default
// import RoomDocComponent from '../Rooms/RoomDocComponent';
import RentMoney from '../RentMoney/Index';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Media from "./Media";
import Grid from "./Grid";
import * as ResponseData from './Saga/ResponseData';
import Button from '@material-ui/core/Button';
import { CSVLink, CSVDownload } from 'react-csv';



interface Props {
    respose_list: any
}




interface State {

}



class CsvButton extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);





    }







    render() {
        return (
            <span>
                <Button style={{ width: 150, borderColor: '#dc143c', marginLeft: 15, fontSize: 15 }} variant="contained" size="large">
                    <CSVLink data={this.props.respose_list}>CSV</CSVLink>
                </Button>
            </span>
        );
    }
};


const mapStateToProps = (state: any) => {
    return {

        respose_list: state.ResponseData.respose_list,

    }
}
function mapDispatchToProps(dispatch: any) {
    return {
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CsvButton);




